import { Column, Row } from '@estee/elc-grid';
import { observer } from 'mobx-react';
import { Heading3 } from '@estee/elc-typography';
import { classes } from '~utils/Classes';
import * as React from 'react';
import classnames from 'classnames';

const titleClassNames = classes('iam-title');
const textClassNames = classes('iam-title-text');

export const SectionHeader = observer((props: { title: string; name?: string }) => {
    const { title, name } = props;

    return (
        <>
            {title && (
                <Row>
                    <Column>
                        <Heading3
                            className={classnames(titleClassNames, {
                                [`iam-title-${name}`]: !!name
                            })}
                        >
                            <div
                                className={classnames(textClassNames, {
                                    [`iam-title-text-${name}`]: !!name
                                })}
                            >
                                {title}
                            </div>
                        </Heading3>
                    </Column>
                </Row>
            )}
        </>
    );
});
